const WEEK_DAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];

function weekMap(fill) {
  return WEEK_DAYS.reduce((acc, day) => {
    acc[day] = fill;
    return acc;
  }, {});
}

export const DEFAULT_SHOP = {
  _id: null,
  name: null,
  description: null,
  googleMapsUrl: null,
  colorTheme: "#21B1FC",
  address: {
    line1: null,
    line2: null,
    district: null,
    region: null,
    country: null,
    postcode: null
  },
  daysOpen: weekMap(false),
  openingTimes: weekMap(null),
  closingTimes: weekMap(null),
  lunchTimes: weekMap(null),
  openingHoursNotes: weekMap(""),
  isEnabled: false,
  lastModified: null,
  serviceSelectionTitle: "Select a Service",
  servicePackageSelectionTitle: "Select a Package",
  employeeSelectionTitle: "Select an Employee",
  timeSelectionTitle: "Select a Time",
  hasCustomerAddressField: false,
  resourceAnyMode: "Off",
  onlinePaymentFee: 0,
  rosterRollingPeriodDays: 0
};

/** Fill missing nested hour maps so the shopfront form can bind every day. */
export function mergeShop(shop) {
  const base = shop || {};
  return {
    ...DEFAULT_SHOP,
    ...base,
    address: {
      ...DEFAULT_SHOP.address,
      ...(base.address || {})
    },
    openingHoursNotes: {
      ...DEFAULT_SHOP.openingHoursNotes,
      ...(base.openingHoursNotes || {})
    }
  };
}
